import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
} from "@/components/ui/dialog";
import { Trophy, CheckCircle, XCircle, AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function DuelNotificationDialog({ open, onClose, type, message, title }) {
    const icons = {
        success: { Icon: CheckCircle, color: 'text-green-500' },
        error: { Icon: XCircle, color: 'text-red-500' },
        warning: { Icon: AlertCircle, color: 'text-orange-500' },
        victory: { Icon: Trophy, color: 'text-[#6E2BFF]' }
    };

    const config = icons[type] || icons.success;
    const Icon = config.Icon;

    return (
        <Dialog open={open} onOpenChange={onClose}>
            <DialogContent className="bg-[#13151D] border-2 border-[#6E2BFF] text-white">
                <DialogHeader>
                    <div className="flex items-center gap-3 mb-2">
                        <Icon className={`w-8 h-8 ${config.color}`} />
                        <DialogTitle className="text-xl font-bold uppercase">{title || 'Notification'}</DialogTitle>
                    </div>
                    <DialogDescription className="text-[#B3B6C2] text-base">
                        {message}
                    </DialogDescription>
                </DialogHeader>
                <Button
                    onClick={onClose}
                    className="w-full bg-[#6E2BFF] hover:bg-[#8B5CFF] text-white font-bold mt-4"
                >
                    OK
                </Button>
            </DialogContent>
        </Dialog>
    );
}